import { selector } from 'recoil'

import { $menuState } from './atoms'

export const $menuIsOpen = selector<boolean>({
  key: 'MenuIsOpen',
  get: ({ get }) => {
    const menuState = get($menuState)
    return menuState?.isOpen || false
  },
  set: ({ set }, value) => {
    set($menuState, {
      isOpen: !value as boolean,
    })
  },
})
